import Vue from "vue";
import Router from "vue-router";

export default function (routes) {
  Vue.use(Router);

  const router = new Router({
    mode: "history",
    routes: routes,
  });
  router.afterEach((to) => {
    Vue.nextTick(() => {
      document.title = to.meta.title;
    });
  });

  return router;
}
